export default __webpack_public_path__ + "static/media/conscentFavicon.467ecf24.svg";